<template>
    <v-btn
        class="ar-cta"
        fab
        @click.prevent="goToAR"
    >
        <v-icon :size="24">
            icon-ar
        </v-icon>
    </v-btn>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'ArButton',
        methods: {
            goToAR() {
                EventBus.$emit('closeSidebar');
                EventBus.$emit('updateLoadedWidgets', {
                    id: 'augmented-reality',
                    link: 'http://frontoffice.habiteo/ar',
                    active: true,
                    widgetType: 'augmented-reality',
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/augmentedReality/components/ArButton.vue